import { useTheme } from "@emotion/react";
import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import { BsFiles } from "react-icons/bs";
import { FaLock, FaRegClock } from "react-icons/fa6";
import { TbClick } from "react-icons/tb";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const requestTypes = [
  {
    id: 1,
    type: "temporary",
    name: "Времена измена на режим за сообраќај",
    description:
      "Оваа форма служи за поднесување барање за привремена измена на сообраќајниот режим. Оваа измена важи за одреден временски период и се користи кога е потребна краткорочна промена на сообраќајните услови.",
    icon: <FaRegClock />,
    button: "Поднеси барање",
  },
  {
    id: 2,
    type: "permanent",
    name: "Трајна измена на режим за сообраќај",
    description:
      "Оваа форма овозможува поднесување барање за трајна измена на сообраќајниот режим, која се однесува на долгорочни промени во организацијата на сообраќајот и инфраструктурата.",
    icon: <FaLock />,
    button: "Поднеси барање",
  },
];

export default function EntryTypeGrid() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  return (
    <Grid item xs={12} md={12}>
      <Grid container spacing={2}>
        {requestTypes.map((item, index) => (
          <React.Fragment key={index}>
            <Grid
              item
              xs={12}
              key={index}
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                color: theme.palette.secondary.main,
                fontFamily: "Inter-Regular",
                fontSize: "17px",
                lineHeight: "1.1",
                transition: "all 0.3s ease",
                width: "100%",
                justifyContent: "center",
                padding: "5px 0",
              }}
            >
              <Grid container spacing={0} style={{ height: "100%" }}>
                <Grid
                  item
                  xs={12}
                  md={5}
                  style={{ backgroundColor: "#efefef", padding: "30px" }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "Inter-Medium",
                      color: "#fff",
                      lineHeight: "1.15",
                      color: theme.palette.secondary.main,
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      marginTop: "10px",
                      lineHeight: "1.2",
                      color: "#565656",
                    }}
                  >
                    {item.description}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={1.65}
                  style={{ backgroundColor: "#efefef", padding: "30px" }}
                />
                <Grid
                  item
                  xs={5.35}
                  style={{
                    background: "linear-gradient(135deg, #045598ff, #0070cc)",
                    padding: "30px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      display: "flex",
                      alignItems: "flex-start",
                      padding: "10px",
                    }}
                  >
                    {React.cloneElement(item.icon, {
                      size: 90,
                      color: "#92c2eaff",
                    })}
                  </div>
                </Grid>
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    width: "280px",
                    position: "absolute",
                    top: "75%",
                    right: "20px",
                    transform: "translateY(-50%)",
                    backgroundColor: "#fff",
                    color: "white",
                    cursor: "pointer",
                    padding: "6px",
                    borderRadius: "2px",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                      transition: "all 0.2s ease",
                    },
                  }}
                  endIcon={
                    <TbClick
                      fontSize={20}
                      color={theme.palette.secondary.main}
                    />
                  }
                  onClick={() => {
                    if (auth?.userData) {
                      if (item.type === "temporary") {
                        navigate("/entries/new/temporary-change", {
                          state: {
                            prev: {
                              pathname: location.pathname,
                              title: "Ново барање",
                            },
                          },
                        });
                      } else if (item.type === "permanent") {
                        navigate("/entries/new/permanent-change", {
                          state: {
                            prev: {
                              pathname: location.pathname,
                              title: "Ново барање",
                            },
                          },
                        });
                      }
                    } else {
                      navigate("/login");
                    }
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Inter-Regular",
                      fontSize: "16px",
                      color: "#171718",
                    }}
                  >
                    {item.button}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
            {!auth?.userData && <Grid item xs={1} />}
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
}
